module.exports = __webpack_public_path__ + "static/media/logo-cheesybit.3e109ca8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/svg/logo-cheesybit.svg
// module id = 464
// module chunks = 0